<template>
  <section class="quotes--quote-header">
    <fixed-header :title="pageTitle" :listPage="'/customerrmas'" hideNewOfferBtn>
      <template v-slot:center>
        <a class="mr-2">Contact</a>
        <div class="edit-contact-container mr-1">
          <edit-contact :companyId="customerrma.companyId" :inlineButton="true" ref="editModal"
            @created="onContactCreated"></edit-contact>
        </div>
        <b-form-select class="w-auto mr-5" v-model="customerrma.contactId">
          <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
            {{ select.firstName + ' ' + select.lastName }}</option>
        </b-form-select>
        <h6 class="mb-0 mr-2">Status:</h6>
        <a class="mr-5">{{ customerrma.statusName }}</a>
        <a class="mr-2">Sales Rep</a>
        <b-form-select v-model="customerrma.salesPersonUserId" class="w-auto">
          <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }}
          </option>
        </b-form-select>
        <span v-if="customerrma.invoiceId" class="ml-3">
          <h6 class="mb-0 mr-2">Invoice:</h6>
          <a class="selector-link" @click="$router.push({ name: 'invoices.edit', params: {id: customerrma.invoiceId } })">
            {{ customerrma.invoiceId  }}
          </a>
        </span>
        <span v-if="customerrma.isAuthorized" class="ml-3">
          <h6 class="mb-0 mr-2">Authorized:</h6>
          <a class="mr-2">{{ customerrma.authorizedByUserFullName + ' on ' + date(customerrma.dateAuthorized) }}</a>
        </span>
      </template>
    </fixed-header>

    <b-card class="quotes-header mb-1">
      <div class="d-flex">
        <address-selector
          @input="customerrma.billingAddressId=$event.id, customerrma.billingAddress=$event.newAddr"
          :value="customerrma.billingAddress"
          :addressId="customerrma.billingAddressId"
          title="Bill to"
          width="300"
          :accountId="customerrma.companyId"
          class="mr-4"
        />
        <address-selector
          @input="customerrma.shippingAddressId=$event.id, customerrma.shippingAddress=$event.newAddr"
          :value="customerrma.shippingAddress"
          :addressId="customerrma.shippingAddressId"
          title="Ship to"
          width="300"
          :accountId="customerrma.companyId"
          class="mr-4"
        />
        <div class="d-flex flex-column header-field-width mr-3">
          <!-- <b-form-group label-cols="4" label-align="right" label="Invoice No.">
            <router-link :to="{
                name: 'invoices.edit',
                params: { id: customerrma.invoiceId },
            }">
            {{ customerrma.invoiceNo }}
            </router-link>
          </b-form-group> -->
          <b-form-group label-cols="4" label-align="right" label="Date">
            <date-picker v-model="customerrma.rmaDate" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label="Action" label-cols="4" label-align="right">
              <b-form-select v-model="customerrma.rmaActionId">
                  <option v-for="action in sortSelect(rmaActions)" :key="action.id" :value="action.id"> {{ action.name }} </option>
              </b-form-select>
          </b-form-group>
          <b-form-group label="Terms" label-cols="4" label-align="right">
              <b-form-select v-model="customerrma.rmaTermsId">
                  <option v-for="terms in sortSelect(rmaTerms)" :key="terms.id" :value="terms.id"> {{ terms.name }} </option>
              </b-form-select>
          </b-form-group>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';
  import moment from 'moment';
  import {
    DATE_FORMAT
  } from '@/shared/constants';
  //import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';

  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
  //import EditAddress from '@/pages/Company/components/CompanyDetails/tabs/Addresses/components/EditAddress/index';
  import AddressSelector from '@/shared/components/AddressSelector/index';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import { dateTime, date } from '@/shared/filters';

  export default {
    components: {
      EditContact,
      //EditAddress,
      AddressSelector,
      FixedHeader,
    },
    data() {
      return {
        text: '11111111',
        date,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        returnActions: [
          'Replacement',
          'Return & Replace',
          'Return for Credit',
          'Return'
        ]
      }
    },
    filters: {
      dateTime,
      date
    },
    watch: {
      quote() {
        if(this.customerrma.quoteDate) {
          this.customerrma.quoteDate = moment(this.customerrma.quoteDate).format(DATE_FORMAT);
        }

        if(this.customerrma.dateAuthorized) {
          this.customerrma.dateAuthorized = moment(this.customerrma.dateAuthorized).format(DATE_FORMAT);
        }

        if(this.customerrma.dateEmailed) {
          this.customerrma.dateEmailed = moment(this.customerrma.dateEmailed).format(DATE_FORMAT);
        }
      },
    },
    computed: {
      ...mapState('customerrmas', ['customerrma']),
      ...mapGetters('quoteDetails', [
        'contacts',
      ]),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('lookup', ['salesTypes', 'incoTerms', 'currencies', 'rmaTerms', 'rmaActions']),
      ...mapGetters('companies', ['companyById']),
      pageTitle() {
        return `Customer RMA: ${this.customerRMAId} - ${this.customerrma.companyName}`;
      },
      company() {
        var result = this.companyById(this.customerrma.companyId);
        return result;
      },
      customerRMAId() {
        return this.$route.params.id;
      },
      // quote() {
      //   // return this.quotes[this.quoteId];
      //   return this.quoteById(this.quoteId);
      // },
      status() {
        var rtn = '';
        switch (this.customerrma.statusId) {
          case 1:
            rtn = 'OPEN';
            break;
          case 2:
            rtn = 'WON';
            break;
          case 3:
            rtn = 'LOST';
            break;
          default:
            rtn = '';
            break;
        }
        return rtn;
      },
    },
    methods: {
      ...mapActions('quoteDetails', [
        'getContacts',
      ]),
      ...mapActions('salesReps', ['getSalesReps']),
      ...mapActions('companies', { getCompanyById: 'getById' }),
      ...mapActions('shippingAccount', ['getShippingAccounts']),
      async onContactCreated(id) {
        await this.getContacts(this.customerrma.accountId);
        this.customerrma.contactId = id;
      },
      redirectToInvoice(invoiceNo) {
        this.$router.push({
          name: 'invoices.edit',
          params: { id: this.customerrma.id },
        });
      }
    },
    async mounted() {
      if(this.customerrma.rmaDate) {
        this.customerrma.rmaDate = moment(this.customerrma.rmaDate).format(DATE_FORMAT);
      }

      if(this.customerrma.dateAuthorized) {
        this.customerrma.dateAuthorized = moment(this.customerrma.dateAuthorized).format(DATE_FORMAT);
      }
      if (this.customerrma.companyId) {
        this.getContacts(this.customerrma.companyId);
        this.getShippingAccounts(this.customerrma.companyId);
        if (Object.keys(this.company).length == 0) {
          this.getCompanyById(this.customerrma.companyId);
        }
      }
    },
  };

</script>

<style scoped>
#sales-order-workflow-status .list-group-item {
  padding: 0.25rem 0.5rem;
  color: #ccc;
}

#sales-order-workflow-status .list-group-item.active {
  background-color: #28a745;
  border-color: #28a745;
  color: #fff;
}

#sales-order-workflow-status .list-group-item.active:before {
  content: '✓';
  margin-right: 0.25rem;
}
.selector-link {
  color: #20a8d8 !important;
  font-size: 100%;
  font-weight: 700;
  padding-bottom: 1px;
}

.selector-link:hover {
  color: #167495 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
